import Tabs from "~components/Tab"
import { UserShape } from "~shapes/user"
import Redemption from "~components/redemption"
import Eligibility from "~components/eligibility"
import ProofOfOwnershipHistorical from "~components/proofOfOwnership/ProofOfOwnershipHistorical"
import Portfolio from "~components/portfolio/Portfolio"
import AggregatedPortfolio from "~components/portfolio/AggregatedPortfolio"
import BrokerConnection from "~components/broker-connection/BrokerConnection"
import UserTicketsTab from "~components/users/UserTicketsTab"
import useSecurities from "~hooks/useSecurities"

interface Props {
  user: UserShape
  isLoading: boolean
  defaultActiveTabId?: string
  highlightedTicketId?: string
}

const getTabs = (
  user: UserShape,
  isLoading: boolean,
  securitiesList: any[] = [],
  highlightedTicketId?: string,
) => [
  {
    id: "aggregated",
    label: "Aggregated portfolio",
    content: isLoading
      ? null
      : !!user && (
          <AggregatedPortfolio userId={user.id} userName={user.profile.name} />
        ),
  },
  {
    id: "portfolios",
    label: "Portfolios",
    content: isLoading
      ? null
      : !!user && (
          <Portfolio
            userId={user.id}
            userName={user.profile.name}
            enableBrokerSelect
            columns={3}
            securities={securitiesList}
          />
        ),
  },
  {
    id: "broker-connection",
    label: "Broker connections",
    content: isLoading ? null : !!user && <BrokerConnection userId={user.id} />,
  },
  {
    id: "poo",
    label: "Proof of ownership",
    content: isLoading
      ? null
      : !!user && <ProofOfOwnershipHistorical user={user} />,
  },
  {
    id: "redemptions",
    label: "Redemptions",
    content: isLoading
      ? null
      : !!user && <Redemption userId={user.id} userEmail={user.email} />,
  },
  {
    id: "eligibility",
    label: "Eligibility",
    content: isLoading ? null : !!user && <Eligibility userId={user.id} />,
  },
  {
    id: "tickets",
    label: "Support tickets",
    content: isLoading
      ? null
      : !!user && (
          <UserTicketsTab
            userId={user.id}
            highlightedTicketId={highlightedTicketId}
          />
        ),
  },
]

const UserDetailTabs = ({
  user,
  isLoading,
  defaultActiveTabId = "aggregated",
  highlightedTicketId,
}: Props) => {
  const { data: securitiesList = [] } = useSecurities()

  return (
    <Tabs
      tabs={getTabs(user, isLoading, securitiesList, highlightedTicketId)}
      defaultActiveTabId={defaultActiveTabId}
      isDisabled={isLoading}
    />
  )
}

export default UserDetailTabs
